import React, { useRef } from 'react';
import { useSelector } from 'react-redux';
import { useCalls } from '@stream-io/video-react-sdk';
import { Button } from '@mui/material';
import { useVideoCallStore } from '../videocall.zustandstore';
import { useAppointmentDetailsContext } from '../../../pages/user/appointmentdetails/contexts/appointmentdetails.context';
import { USER_ROLES } from '../../../utils/constants';
import { GetStreamHandler } from '../GetstreamHandler';

// const CallHandler = () => {
//     const { useCallCallingState } = useCallStateHooks();
//     const callingState = useCallCallingState();
//     // const call = useCall();
//     // console.log({call});
//     // const callingState = useCallCallingState();
//     // console.log({callingState});
//     // const participants = useParticipants();
//     // console.log({participants});

//     if (callingState === CallingState.RINGING) {
//         return <div>Ringing...</div>;
//     }

//     return (
//         <>
//             <SpeakerLayout />
//             {/* <CallControls onLeave={handleCallLeave} /> */}
//             <CallControls />
//         </>
//     );
// };

const CallUI = () => {
    const userState = useSelector(state => state.auth.user);
    const { appointmentDetails } = useAppointmentDetailsContext();
    // console.log({appointmentDetails});
    // console.log({userState});
    const getStreamHandler = useRef(new GetStreamHandler());
    // console.log({gsclient: })
    const { setCall } = useVideoCallStore();
    // const [call, setCall] = useState(null);
    const calls = useCalls();
    // console.log({calls});

    const getIDs = () => {
        const callerData = { mineId: null, userIds: [] };
        const { role } = userState;
        const { doctorId, userId, patientprofile: { firstName: pName }, doctorprofile: { firstName: dName } } = appointmentDetails;
        if (role === USER_ROLES.DOCTOR) {
            callerData.mineId = `${dName}_${doctorId}`;
            callerData.userIds = [`${pName}_${userId}`];
        } else {
            callerData.mineId = `${pName}_${userId}`;
            callerData.userIds = [`${dName}_${doctorId}`];
        }

        return callerData;
    };

    const startCalling = async () => {
        const callerData = getIDs();
        // console.log({callerNames: callerNames.current.value})
        // const callers = callerNames.current.value.split(', ')
        // console.log({callers})
        // // const call = await getStreamHandler.current.ringCall([userName.current.value, ...callers])
        // const callerData = {mineId: client.streamClient.userID, userIds: callers};
        const call = await getStreamHandler.current.ringCall(callerData);
        // console.log({call});
        setCall(call);
    };

    // const handleCallLeave = () => {
    //     console.log('Caller(Me) left');
    //     endCallByCaller();
    // };

    const getCalleeName = () => {
        const { role } = userState;
        if (role === USER_ROLES.DOCTOR) {
            const patient = appointmentDetails?.patientprofile?.firstName;
            return patient ? `Patient ${patient}` : 'Patient';
        } else {
            const doctor = appointmentDetails?.doctorprofile?.firstName;
            return doctor ? `Doctor ${doctor}` : 'Doctor';
        }
    };

    if (calls.length < 1) {
        return (
            <div className='vhCenter'>
                {/* <input type="text" placeholder="Caller Name or ID" ref={callerNames} />&nbsp;&nbsp; */}
                {/* <button role="button" onClick={startCalling}>Start Call</button> */}
                <Button variant='contained' color='primary' onClick={startCalling}>Call {getCalleeName()}</Button>
            </div>
        );
    }

    return null;

    // return (
    //     <StreamCall call={call}>
    //         <CallHandler />
    //     </StreamCall>
    // );
};

export default CallUI;